import React from "react";
import FAQ from "./FAQ";

function FAQPanel() {
    return (
        <div id="faq-section" className="faq-panel">
            <h1>Frequently Asked Questions</h1>
            <FAQ/>
        </div>
    )
}

export default FAQPanel;